import script from "./ModalDomainDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDomainDetails.vue?vue&type=script&setup=true&lang=js"

import "./ModalDomainDetails.vue?vue&type=style&index=0&id=201f24a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201f24a2"]])

export default __exports__